<template>
	<el-dialog :visible.sync="showstocklist" title="选择计划单" :width="width" :append-to-body="true"  :close-on-click-modal="false">
		<stockinlistplan ref="stockinlistplan" :urlparam="searchparam" style="margin-top:-20px"></stockinlistplan>
		<el-row style="margin-top:10px">
			<el-col :span="11" style="color:transparent">1</el-col>
			<el-col :span="8">
				<el-button type="success" size="mini" @click="surestock">确 定</el-button>
				<el-button size="mini" @click="closestock" style="margin-left:10px">取 消</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
import stockinlistplan from '@/pages/stockmanager/stock_inlist_plan';
export default {
	components: {
		stockinlistplan
	},
	props: {},
	data() {
		return {
			width:(window.innerWidth*90/100)+'px',
			showstocklist:false,
			searchparam:{},
			selectsingle:true,//是否只能选择一条
			type:'instockplan'
		};
	},
	mounted() {
		
	},
	methods: {
		init(param) {
			var that=this;
			this.showstocklist=true;
			if(param.selectsingle!=undefined)
				this.selectsingle=param.selectsingle;
			//if(param.searchparam!=undefined){
				//this.searchparam={type:'select',searchparam:param.searchparam};
				this.$nextTick(function(){
					that.$refs.stockinlistplan.init({type:'select'});
				});
			//}
		},
		surestock(){
			//获取勾选的商品
			//this.$refs.cargolist
			//debugger
			var rows=[];
			if(this.$refs.stockinlistplan.selectedall)
				rows=this.$refs.stockinlistplan.orderlist;
			else
				rows=this.$refs.stockinlistplan.checkedrow;
			if(this.selectsingle)
			{
				if(rows.length==1){
					this.$emit('setselectrow',{
						rows:rows,
						type:this.type
					});
				}
				else
				{
					this.$tool.message('请选择一条记录', 2);
					return false;
				}
			}	
			else{
				this.$emit('setselectrow',{
					rows:rows,
					type:this.type
				});
			}
			this.showstocklist=false;
		},
		addstockrow(rows){
			//debugger
			this.$emit('setselectrow', {
				rows:rows,
				type:this.type
			});
			this.showstocklist=false;
		},
		closestock(){
			this.showstocklist=false;
			this.$emit('closestock');
		}
	}
}
</script>

<style>
</style>
